class SpedArquivoController extends AbstractCrudController
  @$inject = ['$injector', '$scope', 'spedArquivoService', 'promiseTracker', 'pathService']
  
  constructor: ($injector, @scope, @spedArquivoService, promiseTracker, pathService) ->
    super($injector, @scope, pathService, false)

    @contratoId = @scope.tabData.contratoId
    @loadingTracker = promiseTracker()
    
    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @listOfMes = [
      {id: 1, nome: 'Janeiro'},
      {id: 2, nome: 'Fevereiro'},
      {id: 3, nome: 'Março'},
      {id: 4, nome: 'Abril'},
      {id: 5, nome: 'Maio'},
      {id: 6, nome: 'Junho'},
      {id: 7, nome: 'Julho'},
      {id: 8, nome: 'Agosto'},
      {id: 9, nome: 'Setembro'},
      {id: 10, nome: 'Outubro'},
      {id: 11, nome: 'Novembro'},
      {id: 12, nome: 'Dezembro'}
    ]

    @scope.$watch(
      () => @empresa,
      () => @loadData() if @empresa          
    )

  configure: (configs) ->
    configs.model = 'spedArquivo'
    configs.module = 'eficiencia-fiscal'
    configs.folder = 'dashboard/sped'

    @setModal('modalSpedArquivo', 'modal', 'spedArquivoModalController')
    @setModal('modalRelatorio', 'relatorioModal', 'spedArquivoRelatorioController')

  loadData: (page = 1) ->
    filtro = {
      contrato: @empresa.id,
      page: page
    }

    @loadingTracker.addPromise @spedArquivoService.getList(filtro, (result) =>
      if result.success
        @listOfData = result.data.items or result.data

        @pagination =
          page: page
          totalPages: result.data.totalPages or result.data.total_pages
          perPage: result.data.page_size || 1
      else
        @Alert.error('Ocorreu um erro ao carregar a listagem.', 'Erro!', false)
    )
    
  hasAcesso: (empresa) ->
    empresa.ferramentasDisponiveis.includes("cruzamento-nfe-x-efd-icms-ipi")

  listOfSpedArquivo: ->
    jQuery.map(@listOfData || [], (spedArquivo) ->
      cruzamento = spedArquivo.historicoCruzamento.slice(-1)?[0] || []

      spedArquivo.ultimoHistoricoCruzamento = {
        ateDia5: cruzamento[0]
        ateDia15: cruzamento[0] + cruzamento[1] + cruzamento[2]
        aPartirDia15: cruzamento[3] + cruzamento[4] + cruzamento[5]
      }

      inconsistencias = spedArquivo.historicoInconsistencias.slice(-1)?[0] || {}
      auditoriaXmlXSped = (v for k, v of inconsistencias when k in ['cst_inconsistente','cfop_inconsistente','valor_incorreto','valor_icms_incorreto','cod_sit_divergente'])
      lancamentoDuplicado = (v for k, v of inconsistencias when k in ['lancamento_duplicado'])
      participantesXml = (v for k, v of inconsistencias when k in ['fornecedor_incorreto'])
      auditoriaDestinatario = (v for k, v of inconsistencias when k in ['destinatario_divergente'])

      spedArquivo.inconsistencias = {
        auditoriaXmlXSped: auditoriaXmlXSped.reduce ((a, b) -> a + b), 0
        lancamentoDuplicado: lancamentoDuplicado.reduce ((a, b) -> a + b), 0
        participantesXml: participantesXml.reduce ((a, b) -> a + b), 0
        auditoriaDestinatario: auditoriaDestinatario.reduce ((a, b) -> a + b), 0
      }

      return spedArquivo
    )

  emitirRelatorio: (spedArquivo, tipo, diaFinal, diaInicial = 1) ->
    if spedArquivo && @empresa.id
      filtro = {
        contrato: @empresa.id
        tipo: tipo
        dataInicial: new Date(spedArquivo.ano, spedArquivo.mes - 1, diaInicial) if tipo == 'cruzamento_nfe_x_sped'
        dataFinal: new Date(spedArquivo.ano, spedArquivo.mes - (if diaFinal is 0 then 0 else 1), diaFinal) if tipo == 'cruzamento_nfe_x_sped'
        mes: spedArquivo.mes if tipo != 'cruzamento_nfe_x_sped'
        ano: spedArquivo.ano if tipo != 'cruzamento_nfe_x_sped'
      }

      cbk.download @pathService.parametrize('/api/eficiencia-fiscal/sped-auditoria/', filtro)
    else
      @modalRelatorio(@modalResolve())

  modalResolve: (spedArquivo = {}) ->
    spedArquivo: => angular.copy spedArquivo
    contrato: => @empresa.id
    listOfMes: => angular.copy @listOfMes
    listOfSpedArquivo: => angular.copy @listOfData

angular.module('eficienciaFiscalModule').controller('spedArquivoController', SpedArquivoController)


class SpedArquivoModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'FileUploader', 'spedArquivo', 'contrato', 'listOfMes',
    'listOfSpedArquivo']

  constructor: ($injector, @modalInstance, FileUploader, @spedArquivo, @contrato, @listOfMes, @listOfSpedArquivo) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @uploader = new FileUploader(
      url: '/api/eficiencia-fiscal/sped-arquivo'
      headers: cbk.getHeaders()
      formData: [{contrato: @contrato}]
    )

    @uploader.onBeforeUpload = =>
      @responseReceived = false

    @uploader.onBeforeUploadItem = (item) =>
      item.formData[0].mes = @spedArquivo.mes
      item.formData[0].ano = @spedArquivo.ano

      return item

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      @responseReceived = true
      if response.success
        mesNome = @listOfMes[@listOfMes.getIndex(@spedArquivo.mes, 'id')].nome
        @Alert.success("Arquivo EFD-ICMS-IPI de #{mesNome}/#{@spedArquivo.ano} foi enviado com sucesso.", 'Sucesso', false)
        @modalInstance.close(new Retorno(response.success, null, response.data))
      else
        @Alert.warning(@getMessage(response.message), 'Atenção', false)

  enviar: (form) ->
    @uploader.uploadAll() if form.$valid

  getMessage: (message) ->
    switch message
      when 'cant_read_file'
        'Não foi possível ler o arquivo. Certifique que esteja enviando um arquivo EFD-ICMS-IPI.'
      when 'version_not_defined'
        'Versão do arquivo não compatível. Certifique que esteja enviando um arquivo EFD-ICMS-IPI.'
      when 'nfes_nao_encontradas'
        'Não foram encontradas NF-es no arquivo EFD-ICMS-IPI.'
      when 'cnpj_diferente_contrato'
        'CNPJ do arquivo EFD-ICMS-IPI diferente da empresa atual.'
      when 'periodo_arquivo_difere_mes_informado'
        'O período do arquivo não está dentro do mês informado.'
      else
        'Ocorreu um erro. Entre em contato com equipe de suporte.'

angular.module('eficienciaFiscalModule').controller('spedArquivoModalController', SpedArquivoModalController)


class SpedArquivoRelatorioController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'pathService', '$filter', 'timeService', 'contrato', 'listOfMes']

  constructor: ($injector, @modalInstance, @pathService, @filter, @timeService, @contrato, @listOfMes) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    @loadingTracker.addPromise @timeService.getList((retorno)=>
      atual = new Date(retorno.dataAtual)
      @relatorio.dataInicial = (new Date(atual.getFullYear(), atual.getMonth(), 1))
      @relatorio.dataFinal = atual
      @relatorio.mes = atual.getMonth()+1
      @relatorio.ano = atual.getFullYear()
    )

    @listOfTiposRelatorio = [
      {tipo: 'cruzamento_nfe_x_sped',   nome: '3.1 Cruzamento de dados NF-e x SPED EFD-ICMS'},
      {tipo: 'auditoria_xml_x_sped',    nome: '3.2 Auditoria de arquivo XML x SPED FISCAL EFD-ICMS'},
      {tipo: 'lancamento_duplicado',    nome: '3.3 Registro de lançamento duplicado de NF-e'},
      {tipo: 'participantes_xml',       nome: '3.4 Auditoria de PARTICIPANTES X CNPJ do XML'},
      {tipo: 'auditoria_destinatario',  nome: '3.5 Auditoria do CNPJ do DESTINATÁRIO do XML'}
    ]

    @relatorio = {}

  emitir: (form) ->
    if form.$valid
      filtro = {
        contrato: @contrato
        tipo: @relatorio.tipo
        dataInicial: @relatorio.dataInicial if @relatorio.tipo == 'cruzamento_nfe_x_sped'
        dataFinal: @relatorio.dataFinal if @relatorio.tipo == 'cruzamento_nfe_x_sped'
        mes: @relatorio.mes if @relatorio.tipo != 'cruzamento_nfe_x_sped'
        ano: @relatorio.ano if @relatorio.tipo != 'cruzamento_nfe_x_sped'
      }

      cbk.download @pathService.parametrize('/api/eficiencia-fiscal/sped-auditoria/', filtro)
      @modalInstance.close(new Retorno(true))

angular.module('eficienciaFiscalModule').controller('spedArquivoRelatorioController', SpedArquivoRelatorioController)
